import { createSlice } from "@reduxjs/toolkit";

import {
  createHelpModuleListAction,
  getHelpModuleListAction,
  updateHelpModuleAction,
} from "@/redux/helpModule/action";
import type { HelpModuleType } from "@/redux/helpModule/helpTypes";
import { initialState } from "@/redux/helpModule/initialState";
import { helpModuleReducer } from "@/redux/helpModule/reducer";

export const helpModuleSlice = createSlice({
  name: "helpModule",
  initialState,
  reducers: helpModuleReducer,

  extraReducers: (builder) => {
    builder.addCase(
      createHelpModuleListAction.pending,
      (state: HelpModuleType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      createHelpModuleListAction.fulfilled,
      (state: HelpModuleType, { payload }) => {
        const { success, status_code, message, result } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            addSuccess: success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          addSuccess: success,
          addMessage: message,
        };
      }
    );

    builder.addCase(
      createHelpModuleListAction.rejected,
      (state: HelpModuleType, { error }) => ({
        ...state,
        addSuccess: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      updateHelpModuleAction.pending,
      (state: HelpModuleType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      updateHelpModuleAction.fulfilled,
      (state: HelpModuleType, { payload }) => {
        const { success, status_code, message, result, _id } = payload;

        if (success === 0) {
          return {
            ...state,
            error: message,
            editSuccess: success,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          editSuccess: success,
          editMessage: message,
        };
      }
    );

    builder.addCase(
      updateHelpModuleAction.rejected,
      (state: HelpModuleType, { error }) => ({
        ...state,
        editSuccess: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );

    builder.addCase(
      getHelpModuleListAction.pending,
      (state: HelpModuleType) => ({
        ...state,
        fetching: true,
      })
    );

    builder.addCase(
      getHelpModuleListAction.fulfilled,
      (state: HelpModuleType, { payload }) => {
        const { status_code, result, message, success, total_count } = payload;
        if (success === 0) {
          return {
            ...state,
            fetching: false,
            success,
            error: message,
            statusCode: status_code,
          };
        }
        return {
          ...state,
          fetching: false,
          helpModuleList: result,
          statusCode: status_code,
          helpModuleTotalCount: total_count,
          message,
        };
      }
    );

    builder.addCase(
      getHelpModuleListAction.rejected,
      (state: HelpModuleType, { error }) => ({
        ...state,
        success: 0,
        error: error?.message ?? null,
        fetching: false,
      })
    );
  },
});
export const {
  resetHelpModuleError,
  resetHelpModuleSuccess,
  resetHelpModuleFetching,
  resetHelpModuleMessage,
  resetHelpModuleListing,
  resetHelpModuleListTotal,
  resetHelpModuleStatusCode,
  resetHelpModuleAddMessage,
  resetHelpModuleEditMessage,
  resetHelpModuleAddSuccess,
  resetHelpModuleEditSuccess,
} = helpModuleSlice.actions;
